import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";

function RecentServices() {
    return (
        <div>
            <Typography variant="body1">
                RecentServices
            </Typography>
        </div>
    );
}

export default RecentServices;